// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro-module--intro--7DbWt","large":"Intro-module--large--3Fypy","greeting":"Intro-module--greeting--I3sqo"};